import useDesktopObservation from './useDesktopObservation';
import { catalogMediaReadinessPresentation } from '@/utils/mediaReadinessPresentation';

export default function useCatalogMediaReadinessStatus() {
  const observation = useDesktopObservation('getCatalogMediaReadinessStatus', 'onCatalogMediaReadinessStatusChanged', {
    validate: value => catalogMediaReadinessPresentation(value).valid === true,
  });
  return { ...observation, desktopAvailable: observation.available };
}
